import { DocumentViewerService } from './document-viewer.service';

export default angular
  .module('sfMobile.services.document-viewer', [
    'sfMobile.services.platform',
    'sfMobile.services.file-system',
  ])
  .service('documentViewerService', DocumentViewerService).name;
